module.exports = __webpack_public_path__ + "static/media/testi_avatar.5ff7c899.png";